import { render, staticRenderFns } from "./AddPaymentReference.vue?vue&type=template&id=7df863c8"
import script from "./AddPaymentReference.vue?vue&type=script&lang=js"
export * from "./AddPaymentReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7df863c8')) {
      api.createRecord('7df863c8', component.options)
    } else {
      api.reload('7df863c8', component.options)
    }
    module.hot.accept("./AddPaymentReference.vue?vue&type=template&id=7df863c8", function () {
      api.rerender('7df863c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/jornalPayment/components/details/AddPaymentReference.vue"
export default component.exports